var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "form comment-form-wrapper",
      attrs: { novalidate: "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.handleSubmit.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "comment-form" },
        [
          _vm.user
            ? _c("img", {
                staticClass: "avatar",
                attrs: { src: `/images/avatar/${_vm.user.id}`, alt: "" },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("TextareaWithMentions", {
            ref: "commentContent",
            model: {
              value: _vm.formData.message,
              callback: function ($$v) {
                _vm.$set(_vm.formData, "message", $$v)
              },
              expression: "formData.message",
            },
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn--icon btn--primary",
              attrs: { disabled: _vm.$wait.is("processing") },
            },
            [
              _vm.$wait.is("processing")
                ? _c("Spinner")
                : _c("SvgIcon", {
                    attrs: { icon: "filled-send", classes: "filled" },
                  }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }